import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { DwollafundingsourceService } from "../../../services/dwollafundingsource.service";
import { DwollatransferService } from "../../../services/dwollatransfer.service";

@Component({
  selector: "app-dwollapaymentpopup",
  templateUrl: "./dwollapaymentpopup.component.html",
  styleUrls: ["./dwollapaymentpopup.component.scss"],
  providers: [ToastrService],
})
export class DwollapaymentpopupComponent implements OnInit {
  dwollaCustomerId: string = "";
  senderFundingSourceData: any[] = [];
  receiverFundingSourceData: any[] = [];
  fundingSourceId;
  pageFilters = {
    amount: "",
    senderFundingSourceId:"",
    senderFundingSourceName: "",
    receiverFundingSourceId:"",
    recieverFundingSourceName:"",
  };
  loadingVisible=false;
  submitClicked= false;
  constructor(
    public dialogRef: MatDialogRef<DwollapaymentpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dwollapayment: DwollatransferService,
    private _toaster: ToastrService,
    private _dwollafundingsources: DwollafundingsourceService
  ) {}

  ngOnInit() {
    console.log("invoice data", this.data);
    this.pageFilters.amount = this.data.amount;
    this._dwollafundingsources
      .getDwollaFundingSourceData(this.data.senderDwollaCustomerId)
      .subscribe((data) => {
        this.senderFundingSourceData = data.result;
      });
    this._dwollafundingsources
      .getDwollaFundingSourceData(this.data.receiverDwollaCustomerId)
      .subscribe((data) => {
        this.receiverFundingSourceData = data.result;
      });
  }
  hidePopup() {
    this.dialogRef.close(null);
  }
  submit(isDwollaPayment){
    this.submitClicked = true;
    if(isDwollaPayment)
    {
      const senderFundingSource = this.senderFundingSourceData.find((f) => f.fundingSourceId === this.pageFilters.senderFundingSourceId);
      const receiverFundingSource = this.receiverFundingSourceData.find((f) => f.fundingSourceId === this.pageFilters.receiverFundingSourceId);
      this.pageFilters.senderFundingSourceName = senderFundingSource.fundingSourceName;
      this.pageFilters.recieverFundingSourceName = receiverFundingSource.fundingSourceName;
      this.dialogRef.close(this.pageFilters);
      /* this.loadingVisible = true;
      this._dwollapayment.SendForm(this.pageFilters).subscribe((res) => {
      this.loadingVisible = false;
      this._toaster.success("Successfully Dwolla Transactions", "Success", {
        timeOut: 2000,
      });
      this.dialogRef.close(this.pageFilters);
      },
        (error) => {
          this.loadingVisible = false;
          let resError = JSON.parse(error._body);
          this._toaster.error(resError.error.error.message, "Failed", {
            timeOut: 4000,
          });
        }) */
    }
    else{
      this._toaster.error("Please fix the validations", "Failed", {
        timeOut: 4000,
      });
    }
  }
}
